
import { Typography, Grid } from "@mui/material";
import React from 'react';
import StarIcon from "@mui/icons-material/Star";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import "./styles.css";

const StatusCard = (props) => {
    const { item } = props

    return (
        <Grid
            className="rating-card"
            style={{
                backgroundColor: item.status.toUpperCase() === 'APPROVED' ? '#F0F8F9' : '#F7F7F7',
                border: item.status.toUpperCase() === 'APPROVED' ? '0.5px solid #3C8C9E' : '0.5px solid #D9D9D9'
            }}
            onClick={() => {
                console.log('')
            }}
        >
            <Grid sx={{ width: "250px" }}>
                <Grid className="grid1">
                    <Typography
                        p={1}
                        style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            letterSpacing: "0.1px",
                            color: "#0D5C75",
                        }}
                    >
                        R {item.amount}
                    </Typography>
                    <Typography
                        p={1}
                        style={{
                            fontSize: "17px",
                            fontWeight: "700",
                            letterSpacing: "0.09px",
                            marginRight: item.status.toUpperCase() === 'APPROVED' ? '25px' : '35px',
                            color:
                                item.status.toUpperCase() === 'APPROVED' ? '#009B2A' : '#B00020'
                        }}
                    >
                        {item.status}
                    </Typography>
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography
                        style={{
                            fontSize: "17px",
                            fontWeight: "400",
                            letterSpacing: "0.09px",
                            color: "#1F1F1F",
                        }}
                        p={1}
                    >
                        {item.name}
                    </Typography>
                    <Typography
                        p={1}
                        className="rating"
                    >
                        {" "}
                        Rating :{" "}
                        <span
                            style={{ color: "black", padding: "0px 5px" }}
                        >
                            {" "}
                            {item.rating}{" "}
                        </span>
                        <StarIcon
                            style={{
                                fontSize: "18",
                                color: "#0d4f57",
                            }}
                        />
                    </Typography>
                </Grid>
            </Grid>
            {item.status.toUpperCase() === 'APPROVED' && <Grid style ={{marginTop:'-85px', marginRight:'-16px', color:'#0D5C75'}}><CheckCircleIcon style={{height:'15px'}}/></Grid>}
        </Grid>

    );
};

export default StatusCard;